import UrlParamsType from "@Form/types/UrlParams.type";
import useForm from "@Form/hooks/useForm";
import rootExtractor from "@Dataset/rootExtractor";

export default function useDisplayStaticContent() {
    const traveling12goPpcAbTestStationCombinations = rootExtractor("travelingPpcAbTestStationCombinations", true) as ([string, string][])
    const urlParams: UrlParamsType = useForm("urlParams")

    const displayStaticData = !!traveling12goPpcAbTestStationCombinations.find((stationCombination) => (
        stationCombination.includes(`${urlParams.fromId}`) && stationCombination.includes(`${urlParams.toId}`)
    ))

    return {
        displayStaticData,
    }
}